import { render, staticRenderFns } from "./veStuAssocLabelShow.vue?vue&type=template&id=49c3763e&scoped=true"
import script from "./veStuAssocLabelShow.vue?vue&type=script&lang=js"
export * from "./veStuAssocLabelShow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49c3763e",
  null
  
)

export default component.exports